export interface OrderLineAgent {
  id: string;
  supplierId: string;
  supplierKey: string;
  supplierName: string;
  supplierSingleLineAddress: string;
  rate: number;
  commissionValue: number;
  rateIsAmount: boolean;
  rateIsAmountYesNo: string;
}
